<template>
    <b-container class="p-0">
        <b-card no-body>
            <!-- FORMULAIRE PARTICULIER -->
            <b-form-group
                :label="$t('PersonnalInformation') + ' :'"
                label-cols="12"
                label-cols-lg="12"
                label-class="font-weight-bold text-dark pt-0 pb-2"
                label-align-sm="left"
                label-size="lg"
                class="bg-white rounded p-2"
                cols="6">
                <!-- NOM -->
                <ValidationProvider rules="required|NoSpecialChar" :name="$t('LastName')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('LastName') + ' *'"
                        label-for="Input_LastName"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_LastName"
                            v-model="customerInfo.LastName"
                            type="text"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- PRÉNOM -->
                <ValidationProvider rules="required|NoSpecialChar" :name="$t('FirstName')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('FirstName') + ' *'"
                        label-for="Input_FirstName"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_FirstName"  
                            v-model="customerInfo.FirstName"   
                            type="text"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- DATE DE NAISSANCE : strictement antérieure à la date du jour -->
                <ValidationProvider rules="before_today" :name="$t('Birthday')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group 
                        :label="$t('Birthday')"
                        label-for="Input_Birthday"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <DatePicker 
                            :Variant="Variant"
                            :Required="false"
                            v-model="customerInfo.Birthday"
                            :State.sync="valid"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
            </b-form-group>
            <!-- ADRESSE -->
            <b-form-group
                :label="$t('Address') + ' :'"
                label-cols="12"
                label-cols-lg="12"
                label-class="font-weight-bold text-dark pt-0 pb-2"
                label-align-sm="left"
                label-size="lg"
                class="bg-white rounded p-2"
                cols="6">
                <!-- ADRESSE -->
                <ValidationProvider rules="required" :name="$t('ClientAddress')" v-slot="{ errors, valid, dirty }" tag="div">
                    <b-form-group
                        :label="$t('Address') + ' *'"
                        label-for="Input_CustomerAddress"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_CustomerAddress"
                            v-model="customerInfo.CustomerAddress"
                            type="text"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- CODE POSTAL -->
                <ValidationProvider rules="required|Zipcode" :name="$t('Zipcode')" v-slot="{ errors, valid, dirty }" tag="div">
                    <b-form-group
                        :label="$t('Zipcode') + ' *'"
                        label-for="Input_CustomerZipcode"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_CustomerZipcode"
                            v-model="customerInfo.CustomerZipcode"
                            type="text"
                            v-mask="'#####'"
                            :state="errors.length > 0 ? false : (valid ? true : false)"
                            placeholder="86000"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- VILLE -->
                <ValidationProvider rules="required|NoSpecialChar" :name="$t('City')" v-slot="{ errors, valid, dirty }" tag="div">
                    <b-form-group
                        :label="$t('City') + ' *'"
                        label-for="Input_CustomerCity"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_CustomerCity"                            
                            v-model="customerInfo.CustomerCity"        
                            type="text"
                            :state="errors.length > 0 ? false : (valid ? true : false)"/>
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
            </b-form-group>
            <!-- CONTACT -->
            <b-form-group
                :label="$t('Contact') + ' :'"
                label-cols="12"
                label-cols-lg="12"
                label-class="font-weight-bold text-dark pt-0 pb-2"
                label-align-sm="left"
                label-size="lg"
                class="bg-white rounded p-2"
                cols="12">
                <!-- EMAIL -->
                <ValidationProvider rules="required|email" :name="$t('Email')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('Email') + ' *'"
                        label-for="Input_Email"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_Email"          
                            v-model="customerInfo.Email"   
                            type="email"
                            placeholder="exemple@domaine.com"
                            :state="errors.length > 0 ? false : (valid ? true : false)" />
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
                <!-- TÉLÉPHONE -->
                <ValidationProvider :rules="PhoneConfig.Rule" :name="$t('Phone')" v-slot="{ errors, valid }" tag="div">
                    <b-form-group
                        :label="$t('Phone')"
                        label-for="Input_Phone"
                        :label-cols-sm="4"
                        label-align-sm="left"
                        class="mb-1">
                        <b-form-input
                            id="Input_Phone"
                            v-model="customerInfo.Phone" 
                            type="text"
                            v-mask="'##########'" 
                            :placeholder="PhoneConfig.PlaceHolder"
                            :state="errors.length > 0 ? false : (valid ? true : false)" />
                        <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                </ValidationProvider>
            </b-form-group>
        </b-card>
    </b-container>
</template>
<script lang="ts">

    /**
     * Composants Vue js
     */
    import { Vue, Component, PropSync, InjectReactive, Prop } from 'vue-property-decorator';

    /**
     * Validation formulaire
     */
    import { ValidationProvider } from 'vee-validate';
    import '@/vee-rules';

    /**
     * Classes
     */
    import { ParticularCustomerInformation } from '@/types/Administration/SMA/CustomerInfo';
    import { PhoneConfig } from '@/types/Administration/SMA/SMADistributorForm';

    /**
     * Composant formulaire (Selection date)
     */
    import DatePicker from '@/components/commons/DatePicker.vue';

    /**
     * Traductions
     */
    import locale from '../../../locales/SMA.json';
    
	@Component({
		components: {
            DatePicker,
            ValidationProvider
        },
        i18n:{messages:locale}
	})
    /**
     * Formulaire distributeur pour les particuliers
     */
	export default class ParticularForm extends Vue {
    
        /**
         * Informations client
         */
        @PropSync('CustomerInfo', { default: () => {} })
        public customerInfo!: ParticularCustomerInformation;
        
        /** 
         * Variant de couleur à appliquer sur le composant 
         */
        @InjectReactive()
        public Variant!: string;

        /**
         * Configuration de validation du téléphone
         */
        @Prop()
        public PhoneConfig!: PhoneConfig;
    }
    
</script>
<style scoped>
</style>